let _cPM = undefined

export default class checkoutDisplay {
    constructor(customPowermail) {
        _cPM = customPowermail || (console.error("CheckoutDisplay -- no cPM given"), false)
        this.htmlElem = document.querySelector(".powermail_fieldwrap_checkout_display")
        this.htmlElemUser = document.querySelector(".powermail_fieldwrap_checkout_user_values")
        this.header = document.querySelector(".powermail_fieldwrap_checkout_display > div .header")
        this.addArticleButton = document.querySelector(".powermail_tab_navigation .btn-warning[type='button']")
        this.items = []
        this.data = undefined

        this.registerValues()
        this.addArticleButtonInit()
        this.refreshDisplay()
        this.moveAddArticleButton()
        this.addEditDataButton()
        this.preventDoubleSend()
    }

    registerValues() {
        let vnameinp = document.querySelector("#powermail_field_vorname"),
            nnameinp = document.querySelector("#powermail_field_nachname"),
            phoneinp = document.querySelector("#powermail_field_telefonnummer"),
            mailinp = document.querySelector("#powermail_field_emailadresse"),
            firminp = document.querySelector("#powermail_field_firma"),
            streetinp = document.querySelector("#powermail_field_strasseundhausnummer"),
            zipinp = document.querySelector("#powermail_field_plz"),
            cityinp = document.querySelector("#powermail_field_ort"),
            handynr = document.querySelector("#powermail_field_handynummer"),
            betriebsnr = document.querySelector("#powermail_field_betriebsnummer")

        /* user */
        vnameinp ? (this.vname = vnameinp.value) : (this.vname = "")
        nnameinp ? (this.nname = nnameinp.value) : (this.nname = "")
        phoneinp ? (this.phone = phoneinp.value) : (this.phone = "")
        mailinp ? (this.mail = mailinp.value) : (this.mail = "")
        /* adress */
        firminp ? (this.ad_firm = firminp.value) : (this.ad_firm = "")
        streetinp ? (this.ad_street = streetinp.value) : (this.ad_street = "")
        zipinp ? (this.ad_plz = zipinp.value) : (this.ad_plz = "")
        cityinp ? (this.ad_city = cityinp.value) : (this.ad_city = "")
        /* additional */
        handynr ? (this.ad_handynr = handynr.value) : (this.ad_handynr = "")
        betriebsnr ? (this.ad_betriebsnr = betriebsnr.value) : (this.ad_betriebsnr = "")
    }

    /**
     * refreshes the display of the checkout
     */
    refreshDisplay() {
        this.registerValues()
        if (_cPM && _cPM.user) {
            _cPM.user.addAdresses()
        }
        this.removeAllArticlesFromDisplay()
        this.displayAllArticles()
        this.displayOrderData()
    }

    displayOrderData() {
        let elem = this.htmlElem,
            ucont = document.querySelector(".ucontent"),
            ucontUser = document.querySelector(".ucont-user"),
            ucontAdress = document.querySelector(".ucont-adress"),
            outField = document.querySelector(".powermail_fieldwrap_checkout_user_values")

        if (elem && outField) {
            // if elems are not yet created - create em
            if (!ucont) {
                ucont = document.createElement("div")
                ucont.setAttribute("class", "ucontent")
                // check for outField
                if (outField) {
                    outField.appendChild(ucont)
                } else {
                    console.error("no outField found - ", outField)
                }
            }

            this.displayUserData(ucontUser, ucont)
            this.displayArticleData(ucontAdress, ucont)
        }
    }

    displayUserData(ucontUser, ucont) {
        if (!ucontUser && ucont) {
            ucontUser = document.createElement("div")
            ucontUser.setAttribute("class", "ucont-user")
            // add user
            var usr1 = document.createElement("p"),
                usr2 = document.createElement("p"),
                usr3 = document.createElement("p"),
                usr4 = document.createElement("p"),
                usr5 = document.createElement("p")

            usr1.innerHTML = "<span>Name, Vorname: </span><span>" + this.vname + ", " + this.nname + "</span>"
            usr2.innerHTML = "<span>Telefon: </span><span>" + this.phone + "</span>"
            usr3.innerHTML = "<span>E-Mail-Adresse: </span><span>" + this.mail + "</span>"

            if (this.ad_handynr != undefined && this.ad_handynr != "") {
                usr4.innerHTML = "<span>Handynummer: </span><span>" + this.ad_handynr + "</span>"
            } else {
                usr4.style.display = "none"
            }

            if (this.ad_betriebsnr != undefined && this.ad_betriebsnr != "") {
                usr5.innerHTML = "<span>Betriebsnummer: </span><span>" + this.ad_betriebsnr + "</span>"
            } else {
                usr5.style.display = "none"
            }

            // set classes
            usr1.setAttribute("class", "ucont-usr1")
            usr2.setAttribute("class", "ucont-usr2")
            usr3.setAttribute("class", "ucont-usr3")
            usr4.setAttribute("class", "ucont-usr4")
            usr5.setAttribute("class", "ucont-usr5")
            // add to parent elem
            ucontUser.append(usr1, usr2, usr3, usr4, usr5)
            ucont.appendChild(ucontUser)
        } else {
            // get and fill user fields
            var usr1 = document.querySelector(".ucont-usr1"),
                usr2 = document.querySelector(".ucont-usr2"),
                usr3 = document.querySelector(".ucont-usr3"),
                usr4 = document.querySelector(".ucont-usr4"),
                usr5 = document.querySelector(".ucont-usr5")
            usr1.innerHTML = "<span>Name, Vorname: </span><span>" + this.vname + ", " + this.nname + "</span>"
            usr2.innerHTML = "<span>Telefon: </span><span>" + this.phone + "</span>"
            usr3.innerHTML = "<span>E-Mail-Adresse: </span><span>" + this.mail + "</span>"
            if (this.ad_handynr != undefined && this.ad_handynr != "") {
                usr4.innerHTML = "<span>Handynummer: </span><span>" + this.ad_handynr + "</span>"
                usr4.style.display = "flex"
            } else usr4.style.display = "none"

            if (this.ad_betriebsnr != undefined && this.ad_betriebsnr != "") {
                usr5.innerHTML = "<span>Betriebsnummer: </span><span>" + this.ad_betriebsnr + "</span>"
                usr5.style.display = "flex"
            } else usr5.style.display = "none"
        }
    }

    displayArticleData(ucontAdress, ucont) {
        if (!ucontAdress && ucont) {
            ucontAdress = document.createElement("div")
            ucontAdress.setAttribute("class", "ucont-adress")
            // add adress
            var adrText = document.createElement("p"),
                adr0 = document.createElement("p"),
                adr1 = document.createElement("p"),
                adr2 = document.createElement("p"),
                adr3 = document.createElement("p")
            adrText.innerHTML = "<span style='color: var(--color-brand)'>Rechnungsadresse</span>"
            this.ad_firm
                ? (adr0.innerHTML = "<span>Firma: </span><span>" + this.ad_firm + "</span>")
                : (adr0.innerHTML = "")
            adr1.innerHTML = "<span>Straße + Nummer: </span><span>" + this.ad_street + "</span>"
            adr2.innerHTML = "<span>Postleitzahl: </span><span>" + this.ad_plz + "</span>"
            adr3.innerHTML = "<span>Ort: </span><span>" + this.ad_city + "</span>"
            adr0.setAttribute("class", "ucont-adr0")
            adr1.setAttribute("class", "ucont-adr1")
            adr2.setAttribute("class", "ucont-adr2")
            adr3.setAttribute("class", "ucont-adr3")
            ucontAdress.append(adr0, adr1, adr2, adr3)
            ucont.appendChild(ucontAdress)
        } else {
            // get and fill adress fields
            var adr0 = document.querySelector(".ucont-adr0"),
                adr1 = document.querySelector(".ucont-adr1"),
                adr2 = document.querySelector(".ucont-adr2"),
                adr3 = document.querySelector(".ucont-adr3")
            this.ad_firm
                ? (adr0.innerHTML = "<span>Firma: </span><span>" + this.ad_firm + "</span>")
                : (adr0.innerHTML = "")
            adr1.innerHTML = "<span>Straße + Nummer: </span><span>" + this.ad_street + "</span>"
            adr2.innerHTML = "<span>Postleitzahl: </span><span>" + this.ad_plz + "</span>"
            adr3.innerHTML = "<span>Ort: </span><span>" + this.ad_city + "</span>"
        }
    }

    moveAddArticleButton() {
        let addArtBtn = document.querySelector(".powermail_fieldset_9 .powermail_tab_navigation")
        let agbBtn = document.querySelector(".powermail_fieldwrap_type_check.powermail_fieldwrap_marker_05")
        if (addArtBtn && agbBtn) {
            addArtBtn.classList.contains("custom") ? undefined : addArtBtn.classList.add("custom")
            agbBtn.before(addArtBtn)
        }
    }

    displayAllArticles() {
        if (this.items && Array.isArray(this.items)) {
            // console.log("displayAllArticles - items: ", this.items);
            this.items.forEach((item) => {
                // console.log("displayAllArticles - item: ", item);
                this.displayArticle(
                    item.category,
                    item.article,
                    item.count,
                    item.date,
                    item.gender,
                    item.omn,
                    item.timestamp,
                    item.message,
                    item.id,
                    item.adress
                )
            })
        }
    }

    removeAllArticlesFromDisplay() {
        let elems = document.querySelectorAll(".cD_article")
        elems.forEach((elem) => {
            elem.remove()
        })
    }

    removeArticleFromDisplay(ID) {
        // console.log("removeArticleFromDisplay: removing article with id: ", ID)
        let elem = document.querySelector("#article-" + ID)
        if (elem) {
            elem.remove()
        } else {
            console.error("no element found to remove - ", elem)
        }
    }

    addAGBLink() {
        let elem = document.querySelectorAll(".powermail_fieldwrap_agb label")[0]
        if (elem) {
            let agbLink = document.createElement("a")
            agbLink.setAttribute("href", "/agb")
            agbLink.setAttribute("target", "_blank")
            agbLink.innerText = "AGB"
            elem.appendChild(agbLink)
        } else {
            // console.error("no AGB link found - ", elem);
        }
    }

    addArticleButtonInit() {
        let btn = document.querySelector(
            ".powermail_fieldset_9 .powermail_tab_navigation button[data-powermail-morestep-show='1']"
        )
        if (btn) {
            let eventType = window.innerWidth <= 1024 && "ontouchend" in window ? "touchend" : "click"
            let checkDisplay = document.querySelector(".powermail_fieldwrap_checkout_display")
            btn.innerText = "Artikel hinzufügen"
            btn.classList.add("btn-add-article")
            btn.id = "add-article-btn"
            btn.addEventListener(eventType, (e) => this.artButtonInit(_cPM))
            /* moves the button to correct position */
            if (checkDisplay && btn) {
                checkDisplay.after(btn)
            }
        }
    }

    /**
     * inits the article button
     * @param {*} cPM
     */
    artButtonInit(cPM) {
        cPM.resetAllArticleInputs()
        cPM.hideAllArticleControls()
        cPM.resetCategory()
        cPM.resetAdressInputs()
    }

    displayArticle(categorieId, article, count, date, gender, omn, timestamp, message, ID, adress) {
        let p = _cPM
        let newArticle = document.createElement("div"),
            newArticleJSON = document.createElement("span"),
            articleImage = document.createElement("img"),
            articleHeader = document.createElement("div"),
            articleContent = document.createElement("div"),
            articleHeaderText = document.createElement("b"),
            articleType = document.createElement("span"),
            articleCount = document.createElement("span"),
            articleDate = document.createElement("p"),
            articleGender = document.createElement("p"),
            articleOmn = document.createElement("p"),
            articleMessage = document.createElement("p"),
            articleAdress = document.createElement("div"),
            articleDeleteButton = document.createElement("span"),
            changeBtn = document.createElement("span")

        changeBtn.id = "article-edit-" + ID
        changeBtn.dataset.orderid = ID
        changeBtn.className = "cD_article__edit"
        this.initChangeBtn(changeBtn, ID)

        newArticle.className = "cD_article"
        newArticle.id = "article-" + ID
        newArticle.dataset.orderid = ID
        newArticleJSON.className = "cD_article__JSON"
        newArticleJSON.id = "cD_article_JSON-" + ID
        articleImage.src = "/fileadmin/system/Icons/"
        articleImage.className = "cD_article__image"
        articleContent.className = "cD_article__content"
        articleAdress.className = "cD_article__adress"
        articleDeleteButton.className = "cD_article__delete"
        articleDeleteButton.id = "article-delete-" + ID
        articleDeleteButton.dataset.orderid = ID
        articleMessage.className = "cD_article__message"

        let categorie
        switch (categorieId) {
            case 0:
                categorie = "Rinder mit Alters­prü­fung per Geburts­datum"
                articleImage.src = "/fileadmin/system/Icons/cow_500x500.svg"
                articleImage.alt = "Rinder mit Altersprüfung per Geburtsdatum"
                break
            case 1:
                categorie = "Schweine / landwirt­schaftliche Nutz­tiere / Wild­tiere "
                articleImage.src = "/fileadmin/system/Icons/pig_500x500.svg"
                articleImage.alt = "Schweine / landwirtschaftliche Nutztiere / Wildtiere"
                break
            case 2:
                categorie = "Haustiere"
                articleImage.src = "/fileadmin/system/Icons/cat_500x500.svg"
                articleImage.alt = "Haustiere"
                break
            default:
                categorie = "Schlacht­abfälle / tierische Neben­produkte / Handels­waren"
                articleImage.src = "/fileadmin/system/Icons/trash_500x500.svg"
                articleImage.alt = "Schlachtabfälle / tierische Nebenprodukte / Handelswaren"
                break
        }

        articleHeaderText.innerText = categorie
        articleType.innerText = article
        articleCount.innerText = "Anzahl: " + count
        articleDate.innerText = "Geburtsdatum: " + date
        articleGender.innerText = "Geschlecht: " + gender
        articleOmn.innerText = "Ohrmarkennummer: " + omn
        articleMessage.innerText = "Ihre Nachricht: " + message

        articleAdress.innerText = adress && adress !== "_origin" ? adress : "Fehler! Keine Adresse gefunden!"
        if (!adress || adress === "_origin") p.disableSubmit()

        // Compose content
        articleHeader.append(articleHeaderText, articleDeleteButton, changeBtn, newArticleJSON)
        articleContent.append(articleHeader, articleType, articleCount)
        if (date) articleContent.appendChild(articleDate)
        if (gender !== "-") articleContent.appendChild(articleGender)
        if (omn.length > 2) articleContent.appendChild(articleOmn) // only add if omn is not empty and not only the Flag
        if (message) articleContent.appendChild(articleMessage)
        newArticle.append(articleImage, articleContent, articleAdress)

        if (document.querySelector("#article-" + ID)) {
            console.warn("element already added to view!")
        } else {
            this.htmlElem.appendChild(newArticle)
            let deleteBtn = document.querySelector("#article-delete-" + ID)
            if (deleteBtn) {
                deleteBtn.addEventListener("click", () => this.deleteOrderObject(ID))
            } else {
                console.error("no delete!! - ", deleteBtn)
            }
        }
    }

    /**
     * handles the edit button of one article
     * @param {string} ID
     */
    editButtonHandling(ID) {
        let p = _cPM
        let dataElems = this.data || undefined
        let btnAddArticle = document.querySelector(".powermail_fieldset_9 .powermail_tab_navigation button[data-powermail-morestep-show='1']")
        let btnSave = document.querySelector(".powermail_tab_navigation .btn-primary.pull-right[data-powermail-morestep-show='2']")
        let btnSaveText = "Änderungen speichern und zurück zur Übersicht"

        // console.log("editButtonHandling: ID: ", ID, " - dataElems: ", dataElems);

        if (Array.isArray(dataElems)) {
            p.resetCategory()
            dataElems.forEach((dEl) => {
                if (dEl[0] === ID) {
                    let [aeID, aeCat, aeArt, aeCount, aeGender, aeDate, aeOmn, aeMsg, aeAdress] = dEl
                    let article = document.querySelector(`.powermail_fieldwrap_checkout_display #article-${aeID}`)
                    if (article) {
                        this.deleteOrderObject(ID)
                    }
                    if (btnAddArticle) {
                        btnAddArticle.click()
                        if (aeCat !== undefined && aeArt !== undefined) {
                            let cat = document.querySelectorAll(".powermail_fieldwrap_article_select .radio"),
                                btnToClick = cat[aeCat]?.querySelector("input"),
                                firstBtn = document.querySelector("#powermail_field_article_select_1"),
                                lastBtn = document.querySelector("#powermail_field_article_select_3")
                            if (btnToClick) {
                                btnToClick.checked = false
                                if (firstBtn) firstBtn.click()
                                if (lastBtn) lastBtn.click()
                                btnToClick.click()
                            }
                            let artRadio = document.querySelector(`input[value='${aeArt}'][type='radio']`)
                            if (artRadio) artRadio.click()
                            let countElem = document.querySelector("#powermail_field_sfg1")
                            if (countElem && countElem.value !== aeCount) countElem.value = aeCount
                            let genderElem = document.querySelector("#powermail_field_sfg2")
                            if (genderElem && genderElem.value !== aeGender) genderElem.value = aeGender
                            let dateElem = document.querySelector("#powermail_field_sfg3")
                            if (dateElem && dateElem.value !== aeDate) dateElem.value = aeDate
                            let omnElem = document.querySelector("#powermail_field_omn")
                            let omnCountryElem = document.querySelector("#powermail_field_omn_country")
                            if (omnElem && omnCountryElem) {
                                if (omnElem.value !== aeOmn) omnElem.value = aeOmn
                                let country = aeOmn ? aeOmn.substring(0, 2) : ""
                                if (omnCountryElem.value !== country) omnCountryElem.value = country
                            }
                            let msgElem = document.querySelector("#powermail_field_msg")
                            if (msgElem) msgElem.value = aeMsg
                            let adr = document.querySelector(`.powermail_fieldwrap_aadress input[value='${aeAdress}']`)
                            if (adr) adr.click()
                        }
                    }
                    if (btnSave) btnSave.innerText = btnSaveText
                }
            })
        } else {
            console.error("cant update - dataElems = undefined")
        }
    }

    /**
     * removes the order object from the display
     * @param {string} orderID
     */
    deleteOrderObject(orderID) {
        console.debug("deleteOrderObject: removing order with id: ", orderID);
        let displayed = document.querySelector("#article-" + orderID)
        if (displayed) {
            if (_cPM.removeArticleFromFinal(orderID)) {

                this.removeArticleFromDisplay(orderID)

                if (_cPM.orderArray.length === 0) {
                    _cPM.firstStep()
                }
                // console.debug("deleteOrderObject: removed order with id: ", orderID);
                // console.log("orderarray. ", _cPM.orderArray, orderID)
                _cPM.renderHumanReadable()
            }
        }
    }

    /**
     * moves the editData button to the right place
     */
    addEditDataButton() {
        let parent = document.querySelector(".powermail_fieldwrap_checkout_user_values .header")
        let editButton = document.querySelector("#edit-data-btn")

        if (!editButton) {
            editButton = document.createElement("span")
            editButton.id = "edit-data-btn"
            editButton.title = "Ihre Daten bearbeiten"
            editButton.setAttribute("tabindex", "0")
            editButton.addEventListener("click", () => {
                let u1 = document.querySelector(".btn-group .btn-default[data-powermail-morestep-current='0']")
                if (u1) {
                    u1.click()
                    try {
                        _cPM.resetAllArticleInputs()
                        _cPM.hideAllArticleControls()
                        _cPM.resetCategory()
                        _cPM.resetAdressInputs()
                        _cPM.unsetUserdataReadonly()
                    } catch (error) {
                        // console.log("tried resetting in editDataRoutine: ", error)
                    }
                }
            })
            this.editDataRoutine()
            if (parent) {
                parent.appendChild(editButton)
            } else {
                console.error("no parent found for editButton - ", parent)
            }
        }
    }

    /**
     * refreshes the display of the editData button
     */
    editDataRoutine() {
        let btn = document.querySelector(".custom-design .powermail_fieldset_7 .powermail_tab_navigation .btn-primary"),
            btn2 = document.querySelector(".custom-design .btn-group .btn-default[data-powermail-morestep-show='1']"),
            btn3 = document.querySelector(
                ".custom-design .powermail_fieldset_7  .powermail_tab_navigation > .btn-primary[data-powermail-morestep-show='1']"
            ),
            btn4 = document.querySelector(".custom-design .btn-group .btn-default[data-powermail-morestep-show='2']")
        if (btn) btn.addEventListener("click", () => this.refreshDisplay())
        if (btn2 && btn2.classList.contains("btn-primary")) btn2.classList.remove("btn-primary")

        let btns = [btn3, btn4]

        btns.forEach((b) => {
            if (!b) return
            b.addEventListener("click", () => {
                _cPM.setUserdataReadonly()
            })
            b.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    _cPM.setUserdataReadonly()
                }
            })
        })
    }

    /**
     * handles the changeButton of one article
     * @param {HTMLElement} btn
     * @param {int} ID
     */
    initChangeBtn(btn, ID) {
        btn.style.display = "none"
        btn.addEventListener("click", () => {
            this.data = _cPM.getFinalData() ?? _cPM.getDataFromFinal()
            this.editButtonHandling(ID)
        })
    }

    /**
     * handles the checkout process
     * @param {boolean} repeat - if true, the checkout process is repeated
     */
    handleCheckout(repeat, order) {
        let _oE = _cPM.activeOrder ? _cPM.activeOrder : order

        if (_oE) {
            var item = undefined
            try {
                item = _oE.tryFinish()
            } catch (error) {
                console.error("handleCheckout: error while trying to finish order - ", error)
            }
            if (item) {
                this.tryValidate(item, repeat, order)
            }
            // console.log("handleCheckout: item to validate - ", item);
        } else {
            console.error("handleCheckout: no active order found - ", _oE)
        }
        // console.log("handleCheckout: finished with repeat: ", repeat, " and order: ", order);
    }

    /**
     * starts the validation of the checkout
     * @param {*} item - the item to validate (mandatory)
     * @param {*} repeat - if true, the checkout process is repeated (optional)
     * @param {*} order - the order to validate (mandatory)
     * @returns {boolean} - true if validation was successful, false otherwise
     */
    tryValidate(item, repeat, order) {
        let _t = _cPM
        if (!item || !order) {
            console.error("tryValidate: no item found - ", item)
            console.error("tryValidate: no order found - ", order)
            return false
        }
        _t.orderArray.push(item)
        _t.checkout.items = _t.orderArray
        _t.checkout.refreshDisplay()
        // repeat checkout id set
        if (repeat) {
            _t.resetAdressInputs()
            _t.resetAllArticleInputs()
            _t.resetCategory()
            // console.log("tryValidate: repeat checkout - resetting inputs and category", document.querySelector(""));
        }
        // console.log("tryValidate: finished and pushed to: ", _t.orderArray);
        // scroll to button display
        _cPM.scrollToElement(".powermail_fieldwrap_article_select", true)
        /* render HR before */
        _cPM.renderHumanReadable()
        return true
    }

    /**
     * Prevents double submission of the form - and adds a loader if submit button was clicked
     * @returns {void}
     */
    preventDoubleSend() {
        var form = document.querySelector(".powermail_form_3");
        if (!form) {
            console.error("preventDoubleSend: Formular nicht gefunden");
            return;
        }

        var btn = form.querySelector('button[type="submit"], input[type="submit"]');
        if (!btn) {
            console.error("preventDoubleSend: Submit-Button nicht gefunden");
            return;
        }

        let _t = this;
        btn.setAttribute("data-custom", "true");
        form.addEventListener('submit', function (event) {
            // 19.08.25: removed checkValidity - cause loader wont get displayed
            // if (form.checkValidity()) {
            if (btn) {
                btn.disabled = true;
                btn.setAttribute("data-loader", _t.showLoader(btn));
                setTimeout(() => {
                    _t.hideAllLoader();
                }, 10000); // Fallback: Loader nach 10 Sekunden entfernen
            }
            // }
        })

        // 29.09.25: only enable submit if AGB is checked + fallback
        let agbLink = document.querySelector("#powermail_field_agb_1");
        if (agbLink) {
            agbLink.addEventListener("change", function () {
                if (this.checked && btn) {
                    btn.disabled = false;
                    btn.setAttribute("data-loader", "false");
                    _t.hideAllLoader();
                }
            });
        }
        // btn.setAttribute("data-loader", _t.showLoader(btn))
    }

    /**
     * Displays a loader next to the element
     * @param {HTMLElement} element - the element to display the loader next to
     * @returns {string} - the ID of the loader element
     * @throws {Error} - if the element is not found or if there is an error while creating the loader element
     */
    showLoader(element) {
        if (!element) {
            console.error("Element not found for loader display");
            return;
        }

        let loader = document.createElement("span")
        loader.className = "loader"
        loader.setAttribute("aria-hidden", "true")
        loader.id = "loader-" + Math.random().toString(36).substring(2, 15);

        try {
            if (element.querySelector(".loader")) {
                element.querySelector(".loader").remove();
            }
            element.after(loader);
        } catch (error) {
            console.error("Error while creating loader element: ", error);
            return false;
        }

        return loader.id;
    }

    hideAllLoader() {
        let loaders = document.querySelectorAll(".powermail_fieldwrap_type_submit .loader");
        loaders.forEach((loader) => {
            loader.remove();
        });
    }
}
